import { DTOInterestTutorialResponse } from './DTOInterestTutorial';

export const PROFILE_INPUT_TYPES = {
  USERNAME: 'USERNAME',
  PROFILE_IMAGE: 'PROFILE_IMAGE',
  INTEREST: 'INTEREST',
} as const;
export type ProfileInputType = (typeof PROFILE_INPUT_TYPES)[keyof typeof PROFILE_INPUT_TYPES];

/** 프로필 입력 팝업 DTO */
export interface DTOProfileInputPopup {
  /** 팝업 ID. 컨벤션: "profile_input.{type}" */
  popupId: string;

  /** 입력 타입. USERNAME, PROFILE_IMAGE, INTEREST 외 타입은 무시 */
  inputType: ProfileInputType;

  /** inputType이 INTEREST인 경우에만 포함. 관심사 선택에 필요한 데이터 */
  interestSelection?: DTOInterestTutorialResponse;
}

/**
 * 프로필 입력 팝업 목록 응답 DTO.
 * GET /api/popups/profile-inputs
 */
export interface DTOProfileInputPopupsResponse {
  result: {
    /** 프로필 입력 팝업 목록 */
    popups: DTOProfileInputPopup[];
  };
}
